import { render, staticRenderFns } from "./StandbyIndex.vue?vue&type=template&id=7ab5fd30"
import script from "./StandbyIndex.vue?vue&type=script&lang=js"
export * from "./StandbyIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports